import { getCurrentSeason } from "@/lib/date-utils"

export type TimelineUrlOptions = {
  zipCode: string
  grassType?: string | null
  savedAnalysisId?: string | null
  resultAccessToken?: string | null
  lawnId?: string | null
  uploadedImageUrl?: string | null
  email?: string | null
  season?: ReturnType<typeof getCurrentSeason>
}

/**
 * Builds the canonical timeline URL for homepage/result handoffs.
 * Keeping this centralized prevents query params and encoding rules from
 * drifting between anonymous, authenticated, and OAuth-return flows.
 */
export function buildTimelineUrl(options: TimelineUrlOptions): string {
  const params = new URLSearchParams()

  params.set("zipCode", options.zipCode)
  if (options.grassType) params.set("grassType", options.grassType)
  if (options.email) params.set("email", options.email)
  params.set("season", options.season ?? getCurrentSeason())
  if (options.uploadedImageUrl) params.set("imageUrl", options.uploadedImageUrl)
  if (options.savedAnalysisId) params.set("analysisId", options.savedAnalysisId)
  if (options.resultAccessToken) params.set("access", options.resultAccessToken)
  if (options.lawnId) params.set("lawnId", options.lawnId)

  return `/timeline?${params.toString()}`
}
